import React, {useCallback, useMemo, useState} from "react";
import {Outlet} from "react-router-dom";
import {Layout} from "../../components";

export type LayoutOptions = {
    withoutMenu?: boolean;
    route?: string;
    handleBack?: () => void;
};

export type LayoutOutletContext = {
    setLayoutOptions: (next: LayoutOptions) => void;
    resetLayoutOptions: () => void;
};

const DEFAULT_OPTIONS: LayoutOptions = {
    withoutMenu: false,
    route: undefined,
    handleBack: undefined
};

const PageOutlet = () => {
    const [options, setOptions] = useState<LayoutOptions>(DEFAULT_OPTIONS);

    const setLayoutOptions = useCallback((next: LayoutOptions) => {
        setOptions((prev) => ({...prev, ...next}));
    }, []);

    const resetLayoutOptions = useCallback(() => {
        setOptions(DEFAULT_OPTIONS);
    }, []);

    const ctxValue = useMemo<LayoutOutletContext>(
        () => ({setLayoutOptions, resetLayoutOptions}),
        [setLayoutOptions, resetLayoutOptions]
    );

    return (
        <Layout
            withoutMenu={Boolean(options.withoutMenu)}
            route={options.route}
            handleBack={options.handleBack}
        >
            <Outlet context={ctxValue}/>
        </Layout>
    );
};

export default PageOutlet;
